import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Observable, fromEvent } from 'rxjs';

import * as $ from 'jquery';

@Component({
  selector: 'app-9-reasons-to-invest',
  templateUrl: './9-reasons-to-invest.component.html'

})
/** 9-reasons-to-invest component*/
export class ReasonsToInvestComponent implements OnInit {

  private hasTriggered = false;
  //@ContentChild(ChildComponent) contentChild: ChildComponent;
  private documentDone: Observable<any>

  constructor(@Inject(DOCUMENT) private document: any) { }

  ngOnInit() {
    console.clear();
    this.hasTriggered = false
    this.documentDone = fromEvent(this.document, 'readystatechange');
    this.documentDone.subscribe(state => this.scrollToContent());
    
  }

  scrollToContent() {
    //console.log('Scrolling!!')
    if (location.hash) {
      setTimeout(function () {
        //console.log("Scroll to:" + location.hash);
        //this.scroll("body", $(location.hash));
        const scrollTo = $(location.hash).offset().top-110;
        //console.log("offset: " + scrollTo);
        $('html, body').stop().animate({ scrollTop: scrollTo }, 500);
      }, 500);
    }
  }

  


}
